export const GET_CANDIDATE_ASSESSMENT = 'GET_CANDIDATE_ASSESSMENT'
export const GET_CANDIDATE_ASSESSMENT_PENDING = 'GET_CANDIDATE_ASSESSMENT_PENDING'
export const GET_CANDIDATE_ASSESSMENT_FULFILLED = 'GET_CANDIDATE_ASSESSMENT_FULFILLED'
export const GET_CANDIDATE_ASSESSMENT_REJECTED = 'GET_CANDIDATE_ASSESSMENT_REJECTED'

export const CREATE_SUBMITTED_ASSESSMENT = 'CREATE_SUBMITTED_ASSESSMENT'
export const CREATE_SUBMITTED_ASSESSMENT_PENDING = 'CREATE_SUBMITTED_ASSESSMENT_PENDING'
export const CREATE_SUBMITTED_ASSESSMENT_FULFILLED = 'CREATE_SUBMITTED_ASSESSMENT_FULFILLED'
export const CREATE_SUBMITTED_ASSESSMENT_REJECTED = 'CREATE_SUBMITTED_ASSESSMENT_REJECTED'

export const CLEAR_GET_CANDIDATE_ASSESSMENT = 'CLEAR_GET_CANDIDATE_ASSESSMENT'
